import _ from 'lodash';
import moment from 'moment';

const ArrayUtils = (() => {
  const service = {};

  const selectivelyFlattenJSONArrayObjects = (passedArray, propertiesToExtract = [ 'value', '$date', ], doNotFormat = []) => {
    const iterableArray = passedArray;

    Object.keys(passedArray).forEach((passedObjectKey) => {
      Object.keys(passedArray[passedObjectKey]).forEach((key) => {
        if (typeof passedArray[passedObjectKey][key] === 'object') {
          const selected = _.pick(passedArray[passedObjectKey][key], propertiesToExtract);
          if (selected) {
            if (Object.keys(selected)[0] && !doNotFormat.includes(Object.keys(selected)[0])
                && (Object.keys(selected)[0].toLowerCase().includes('date')
                    || Object.keys(selected)[0].toLowerCase().includes('timestamp'))) {
              iterableArray[passedObjectKey][key] = moment(
                Object.values(selected)[0]
              )
                .utc().format();
            } else {
              const newValue = Object.values(selected)[0];
              iterableArray[passedObjectKey][key] = newValue;
            }
          }
        }
      });
    });

    return iterableArray;
  };

  service.selectivelyFlattenJSONArrayObjects = selectivelyFlattenJSONArrayObjects;

  return service;
})();

export default ArrayUtils;
